import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { ScheduledItemCalendar, ScheduledItemLabel, ScheduledItemArrowButton } from 'components/Calendar'
import { Spacer } from 'components/Utility'
import { Card, CardInner } from 'components/Card'

type Props = {
  currentDate: Date
  currentMonth: Date
  handleCurrentMonth: (date: Date) => void
}

const ScheduledItemCalendarContainer: FC<Props> = (props) => {
  const { currentDate, currentMonth, handleCurrentMonth } = props

  return (
    <Card>
      <CardInner>
        <div className={styles.calendar__monthly__header}>
          <ScheduledItemArrowButton
            currentMonth={currentMonth}
            handleCurrentMonth={handleCurrentMonth}
            label={'前月'}
            type={'prev'}
          />
          <ScheduledItemLabel currentMonth={currentMonth} />
          <ScheduledItemArrowButton
            currentMonth={currentMonth}
            handleCurrentMonth={handleCurrentMonth}
            label={'翌月'}
            type={'next'}
          />
        </div>
        <Spacer size={16} />
        <ScheduledItemCalendar currentDate={currentDate} currentMonth={currentMonth} />
      </CardInner>
    </Card>
  )
}

export default ScheduledItemCalendarContainer
